import { render } from "./SimpleNoteCreateConceptsCard.vue?vue&type=template&id=b0606c62"
import script from "./SimpleNoteCreateConceptsCard.vue?vue&type=script&lang=js"
export * from "./SimpleNoteCreateConceptsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__